import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom'
import withAuth from '../auth_components/js/withAuth';
import Navbar from '../Components/Navbar';
import AboutUsHomeLanding from '../Components/AboutUs/AboutUsHomeLanding';

class AboutUsContainer extends Component {
    constructor(props) {
        super(props);

        let user = JSON.parse(localStorage.getItem('user'));

        this.state = {
            apikey: user.user.apikey,
            username: user.user.email,
            name: user.user.name,
            role: user.user.name
        }
    }

    render() {
        return (
            <div>
                <Navbar history={this.props.history} />
                <div className="main-body">
                    <Switch>
                        <Route exact path="/about-us" render={(props) =>
                            <AboutUsHomeLanding
                                {...props}
                                history={this.props.history}
                                title="About Us"
                                code="ABOUT_US"
                                apikey={this.state.apikey}
                                username={this.state.username}
                            />} />
                    </Switch>
                </div>
            </div>
        )
    }
}

export default withAuth(AboutUsContainer);
